import {
  communityPath,
  homePath,
  pickemPath,
  matchesPath,
  tracksPath,
  loginPath,
  tournamentsPath,
  aboutUsPath,
} from "pages/PageConfigs";
import { useLocation, useNavigate } from "react-router-dom";
import { MaxWidth } from "styles/layout";
import { AccountDropdown } from "./AccountDropdown/AccountDropdown";
import { BurgerMenu } from "./BurgerMenu/BurgerMenu";
import {
  NavBarContainer,
  NavItem,
  NavOptions,
  NavBarAccountContainer,
  LoginButton,
  BurgerMenuContainer,
  HomeNavItem,
  LogoImg,
} from "./styles";
import { useAppSelector } from "app/hooks";

export const NavBar = () => {
  const navigate = useNavigate();
  const prevLocation = useLocation();
  const { uid } = useAppSelector((state) => state.user);
  const toLogin = () => {
    navigate(loginPath, {
      replace: true,
      state: { prev: prevLocation.pathname },
    });
  };

  return (
    <NavBarContainer>
      <MaxWidth>
        <NavOptions>
          <BurgerMenuContainer>
            <BurgerMenu />
          </BurgerMenuContainer>
          <HomeNavItem to={homePath}>
            <LogoImg src={`/images/ecm/logo.png`} />
          </HomeNavItem>
          <NavItem to={pickemPath}>Pick'em</NavItem>
          <NavItem to={matchesPath}>Matches</NavItem>
          <NavItem to={tournamentsPath}>Tournaments</NavItem>
          <NavItem to={tracksPath}>Tracks</NavItem>
          <NavItem to={communityPath}>Community</NavItem>
          <NavItem to={aboutUsPath}>About Us</NavItem>
          <NavBarAccountContainer>
            {!uid ? (
              <LoginButton onClick={toLogin}>Login</LoginButton>
            ) : (
              <AccountDropdown />
            )}
          </NavBarAccountContainer>
        </NavOptions>
      </MaxWidth>
    </NavBarContainer>
  );
};
